import React, { useState, useEffect } from "react";
import { Button } from "../../Components";
import OtpInput from "./OtpInput";
import CountdownTimer from "../commonComponent/CountdownTimer";
import Header from "../commonComponent/Header";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import {
  otpVerify,
  pincodeVerify,
  sendOtp,
  sendPincode,
  checkSubcription,
} from "../API/apiRequest";
import Loader from "../commonComponent/Loader";
import { page, event, key } from "../../events/event";

import { Base64 } from "js-base64";
import { countryCode } from "../config/wapConfig";
import axios from "axios";

function Otp() {
  const location = useLocation();
  const sms = location?.state?.sms;
  console.log(sms,"sms")
  const TIME_LEFT_FOR_OTP = 120;
  const OTP_LENGTH = sms ? 4 : 5 
  const msisdn = localStorage.getItem("msisdn");
  const { type } = queryString.parse(window.location.search);
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [isWrongOTP, setIsWrongOTP] = useState(false);
  const [otpTime, setOtpTime] = useState(TIME_LEFT_FOR_OTP);
  const [isLoader, setIsLoader] = useState(false);
  const [id,setId] = useState("");
  const getLang = "ar";
  const uid = `m=${countryCode.substring(1)+msisdn}`;

  useEffect(() => {
   setIsLoader(true);
    axios.get('https://xgames.bngrenew.com/api/mcpScript?Servicefor=zain_iq_dtk&flow=nonhe')
      .then(async (resp) => {
        console.log("mcpApi response:::", resp);

        const sourceCode = await resp?.data?.source;
        if (resp?.data?.uniqid) {
          localStorage.setItem("uniqid", resp.data.uniqid);
          setId(resp.data.uniqid);
        }
        if (sourceCode) {
          const script = document.createElement('script');
          script.type = "text/javascript";
          script.id = "sourceCode";
          script.innerHTML = sourceCode;
          document.head.appendChild(script);
        }

        setIsLoader(false);

      })
      .catch((err) => {
        setIsLoader(false);
        console.log("error in mcp api::", err);
      });

    return () => {
      setIsLoader(false);
    }
    
  }, []);


  const handleOtpVerify = () => {

    setIsLoader(true);
    if (type === "pincode") {

      pincodeVerify(msisdn, otp, id)
        .then((resp) => {

          if (resp?.status?.toLowerCase() === "success") {
            handlePinCheckSub();
          } else {
            setIsWrongOTP(true);
            setOtp("");
            setIsLoader(false);
          }
          console.log("pincodeVerify api resp::", resp);
        })
        .catch((err) => {
          setIsLoader(false);
          console.log("pincodeVerify api error ::", err);
        });
    } else {

      otpVerify(msisdn, otp)
        .then((resp) => {

          if (resp?.status?.toLowerCase() === "success") {
            handleOtpCheckSub();
          } else {
            setIsWrongOTP(true);
            setIsLoader(false);
            setOtp("");
          }

          console.log("otpVerify api resp::", resp);
        })
        .catch((err) => {
          setIsLoader(false);
          console.log("otpVerify api error ::", err);
        });
    }
  };

  const handlePinCheckSub = () => {

    checkSubcription(msisdn)
      .then((resp) => {
        console.log("Checksub api response::", resp);
        if (resp) {
          setIsLoader(false);
          const currentStatus = resp?.currentStatus?.toLowerCase();

          if (currentStatus === "active" || currentStatus === "demo") {
            navigate(`/sub-status?id=7`);
          } else if (currentStatus === "grace"){
            navigate(`/sub-status?id=4`);
          }
          else{
            navigate(`/sub-status?id=1`);
          }
        }
      })
      .catch((err) => {
        setIsLoader(false);
        console.log("Checksub api error::", err);
      });
  };

  const handleOtpCheckSub = () => {

    checkSubcription(msisdn)
      .then((resp) => {
        console.log("Checksub api response::", resp);
        if (resp) {
          setIsLoader(false);
          const currentStatus = resp?.currentStatus?.toLowerCase();


          if (currentStatus === "active" || currentStatus === "demo") {
            navigate(`/home?uid=${Base64.encode(uid)}`);
          } else {
            navigate(`/sub-status?id=4`);
          }
        }
      })
      .catch((err) => {
        setIsLoader(false);
        console.log("Checksub api error::", err);
      });
  };

  const handleResendOTP = () => {
    setIsLoader(false);
    setOtpTime(TIME_LEFT_FOR_OTP);
    if (type === "pincode") {


      sendPincode(msisdn)
        .then((resp) => {
          setIsLoader(false);


          if (resp?.status?.toLowerCase() === "success") {
            setOtp("");
          }
          console.log("sendPincode reponse::", resp);
        })
        .catch((err) => {
          setIsLoader(false);
          console.log("sendPincode api error::", err);
        });
    } else {

      sendOtp(msisdn)
        .then((resp) => {
          setIsLoader(false);

          if (resp?.status?.toLowerCase() === "success") {
            setOtp("");
            navigate("/home");
          }
          console.log("sendOtp reponse::", resp);
        })
        .catch((err) => {
          setIsLoader(false);
          console.log("sendOtp api error::", err);
        });
    }
  };

  return (
    <>
      {isLoader && <Loader />}
      <div className="bg-darkPurple flex flex-col h-screen">
        <Header />
        <div className="flex-grow mt-6">
          <div className="mt-2 flex text-center flex-col items-center text-white">
            <div className="h-20 w-20 rounded-full mb-2">
              <img
                src={
                  isWrongOTP
                    ? require("../..//Assets/wap/daretoknowAssets/wrong_otp.png")
                    : require("../../Assets/wap/daretoknowAssets/otp.png")
                }
              />
            </div>
            <div
              className={`font-semibold text-3xl ${
                getLang === "ar" ? "arabic-lang" : ""
              }`}
            >
              {isWrongOTP === true ? "عذراً" : "الرقم السري المتغير OTP"}
            </div>
            <div className="my-4">
              <div
                className={`max-w-80 w-80 ${
                  getLang === "ar" ? "arabic-lang" : ""
                }`}
              >
                {isWrongOTP
                  ? "الرقم السري المتغير OTP الذي أدخلته غير صحيح"
                  : sms ? "الرجاء إدخال الرمز المكوّن من 4 أرقام الذي تلقيته على هاتفك المحمول" :" الرجاء إدخال الرمز المكوّن من 5 أرقام الذي تلقيته على هاتفك المحمول"}
              </div>
              {isWrongOTP && (
                <div
                  className={`text-buttonYellow text-lg mb-4 ${
                    getLang === "ar" ? "arabic-lang" : ""
                  }`}
                >
                  حاول مرة أخرى
                </div>
              )}
            </div>

            <OtpInput length={OTP_LENGTH} setOtp={setOtp} otp={otp} />
            {sms ? <div
              className={`w-64 mt-4 flex ${
                getLang === "ar" ? "arabic-lang" : ""
              }`}
            >
                احصل على الرقم السري المتغير المكوّن من 4 أرقام على هاتفك {" "}
              <span className="text-buttonYellow ml-2">
                <CountdownTimer initialTime={otpTime} />
              </span>
            </div> : <div
              className={`w-64 mt-4 flex ${
                getLang === "ar" ? "arabic-lang" : ""
              }`}
            >
                احصل على الرقم السري المتغير المكوّن من 5 أرقام على هاتفك {" "}
              <span className="text-buttonYellow ml-2">
                <CountdownTimer initialTime={otpTime} />
              </span>
            </div>}
            <div className={`${getLang === "ar" ? "arabic-lang" : ""}`}>
              لم تتلقي رسالة نصية؟
              <span
                onClick={handleResendOTP}
                className={`text-buttonYellow cursor-pointer ml-2 font-semibold ${
                  getLang === "ar" ? "arabic-lang" : ""
                }`}
              >
                إعادة إرسال الرمز
              </span>
            </div>
            <Button
              name="تأكيد الشراء"
              handleClick={handleOtpVerify}
              id="cta_button"
              className="h-12 bg-buttonYellow mt-8 rounded-full font-bold  text-darkPurple text-xl w-80"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Otp;
